import Vue from 'vue';

import saveFooter from '@/components/saveFooter';
import title from '@/components/title';

Vue.component('save-footer', saveFooter);
Vue.component('view-title', title);
